// extracted by mini-css-extract-plugin
module.exports = {"footer":"classes_footer__2tOb5"};